import React, { useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { useParams } from 'react-router-dom';

import { fetchCandidate, fetchValidatedWorkClaims } from 'api';
import { useSnackContext } from 'hooks/useSnackContext';
import { ReviewedFullCandidateProps } from 'types';
import { FullValidatedWorkClaimProps } from 'types/Claims';

import { ReviewedCandidate } from './ReviewedCandidate';

export const ReviewedCandidatePage = () => {
  const { setSnack } = useSnackContext();
  const { candidate_id } = useParams<{ candidate_id: string }>();
  const [candidate, setCandidate] = useState<ReviewedFullCandidateProps | null>(
    null,
  );
  const [loading, setLoading] = useState(false);
  const [validatedWorkClaims, setValidatedWorkClaims] = useState<
    Array<FullValidatedWorkClaimProps>
  >([]);

  useEffect(() => {
    async function getCandidate() {
      try {
        setLoading(true);
        const { data } = await fetchCandidate(parseInt(candidate_id, 10));
        setCandidate(data);
        const res = await fetchValidatedWorkClaims({
          params: { candidate_id: candidate_id },
        });
        setValidatedWorkClaims(res.data);
        setLoading(false);
      } catch (e) {
        setSnack((props) => ({
          ...props,
          severity: 'error',
          open: true,
          message: `Failed To Get Candidate ${candidate_id}`,
          error: e as Error,
        }));
      }
    }
    getCandidate();

    return () => {
      setValidatedWorkClaims([]);
      setCandidate(null);
    };
  }, [candidate_id, setCandidate, setSnack]);

  if (!candidate || loading) {
    return <LinearProgress sx={{ width: '100%' }} />;
  }

  return (
    <ReviewedCandidate
      setCandidate={
        setCandidate as React.Dispatch<
          React.SetStateAction<ReviewedFullCandidateProps>
        >
      }
      candidate={candidate}
      validatedWorkClaims={validatedWorkClaims}
    />
  );
};
